
import React, { useEffect, useRef, useState } from 'react'

import { NavLink, useNavigate } from 'react-router-dom';
import "./banner.scss"
import { axiosApi } from '../../../../_helper/api_helper';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Rating from '@mui/material/Rating';
import { useDispatch, useSelector } from 'react-redux';
import { industriesget } from '../../../../store/industries/action';
import LoadingPannel from '../../../../commonComponent/LoadingPannel/LoadingPannel';

const Banner = () => {

    
    const searchJobandProject = [
        { id: 0, name: "Find Projects" },
        { id: 1, name: "Find Jobs" }
    ];
    const searchFreelanceFilter = [ 
        { id: 0, name: "Find Talents" },
        { id: 1, name: "Find Projects" },
        { id: 2, name: "Find Jobs" }
    ];
    const navigate = useNavigate();

    const videoRef = useRef(null);


    const clientId = localStorage.getItem("client_Id");
    const recuiterId = localStorage.getItem("recuiter_Id");

    const [searchInput, setSearchInput] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [subCategory, setSubCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(searchJobandProject[0].id);
    const [selectedFreelanceCategory, setSelectedFreelanceCategory] = useState(searchFreelanceFilter[0].id);
    const [selectedDropdownItem, setSelectedDropdownItem] = useState(null);
    const [videoLoading, setVideoLoading] = useState(true);
    const [trusted, setTrusted] = useState([]);
    const [industries, setIndustries] = useState([]);

    const [selectedIndustryName, setSelectedIndustryName] = useState('');
    const [selectedSkillName, setSelectedSkillName] = useState('');
    const [subcategories, setSubcategories] = useState([]);
    const [formvalues, setFormValues] = useState({
        Occupation_industry: "",
        project_price: "",
        Occupation_skills: "",


    });


  
    const handleCategoryChange = (e) => {
        const selectedSkillName = e.target.value;
        setSelectedSkillName(selectedSkillName);
        setFormValues({ ...formvalues, Occupation_skills: selectedSkillName });
    };
    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            const playVideo = () => {
                video.play().catch(() => {
                    video.muted = true;
                    video.play();
                });
            };

            // Try to play the video when the component mounts
            playVideo();

            // Fallback for browsers that need user interaction
            video.addEventListener('click', playVideo);

            return () => {
                video.removeEventListener('click', playVideo);
            };
        }
    }, [])


    useEffect(() => {

        subCategoryData();
        trustedApi();
        IndustriesGet();
    }, []);
    const handleVideoLoaded = () => {
        // setVideoLoading(false);  
    };

    // useEffect(() => {
    //     if (getIndustries?.length > 0) {
    //         setIndustries(getIndustries);
    //     }
    // }, [getIndustries]);
    // useEffect(() => {
    //     dispatch(industriesget());
    //   }, [dispatch]);


    const IndustriesGet = async () => {
        setVideoLoading(true);
        try {
            const response = await axiosApi.get("/industries");
            setIndustries(response?.data);
            setVideoLoading(false);

        } catch (error) {                       
            setVideoLoading(false);
        }

    }
    const handleIndustryChange = (e) => {
        const selectedIndustryId = e.target.value;
        const selectedIndustry = industries.find(industry => industry.id === selectedIndustryId);

        setSelectedIndustryName(selectedIndustry ? selectedIndustry.name : '');
        setFormValues({ ...formvalues, Occupation_industry: selectedIndustryId });


        if (selectedIndustryId) {
            axiosApi.get(`/industries/${selectedIndustryId}`)
                .then(response => {
                    setSubcategories(response.data.occupation_skills || []);
                })
                .catch(error => {
                    console.error("There was an error fetching the subcategories!", error);
                    setSubcategories([]);
                });
        } else {
            setSubcategories([]);
        }
    };

    const trustedApi = async () => {
        try {
            const response = await axiosApi.get(`/trustusercount`);
            setTrusted(response?.data);
        } catch (error) {
            console.error('Error fetching trusted data:', error);
        }
    };
    const subCategoryData = async () => {
        const response = await axiosApi.get(`/occupation-skillss`);
        setSubCategory(response?.data);
    }
    useEffect(() => {
        // Filter the ServiceData based on the search input
        if (searchInput) {
            const results = subCategory.filter(service =>
                service.name.toLowerCase().includes(searchInput.toLowerCase())
            );
            setFilteredData(results);
        } else {
            setFilteredData([]);
        }
    }, [searchInput, subCategory]);

    const handleItemClick = (item) => {

        setSelectedDropdownItem(item); // Set the entire item object
        setSearchInput(item); // Update the input field with the selected name
        setFilteredData([]); // Clear the dropdown after selection
    };
    const filteredDropdown = filteredData.filter(
        (service) => service.name.toLowerCase() !== searchInput.toLowerCase()
    );

    const handleSearchNavigate = () => {

        if (selectedIndustryName && selectedSkillName) {
            if (selectedFreelanceCategory == Number(0)) {
                navigate(`/view-all-freelancer/${selectedIndustryName}/${selectedSkillName}`);
            } else if (selectedFreelanceCategory == Number(1)) {
                // navigate(`/all-projects/${selectedIndustryName}/${selectedSkillName}`);
                navigate(`/all-project-posted/${selectedIndustryName}/${selectedSkillName}`);
            }
            else if (selectedFreelanceCategory == Number(2)) {
                navigate(`/hire-talent/${selectedIndustryName}/${selectedSkillName}`);
            }
            else {
                alert('Please select both a category and subcategory');
            }
        } else {
            alert('Please select both a category and subcategory');
        }

    };


    const handleSearch = () => {
        if (selectedIndustryName && selectedSkillName) {
            if (selectedCategory == Number(0)) {
                navigate(`/all-project-posted/${selectedIndustryName}/${selectedSkillName}`);
            }
            else if (selectedCategory == Number(1)) {
                navigate(`/hire-talent/${selectedIndustryName}/${selectedSkillName}`);
            }
            else {
                alert('Please select both a category and subcategory');
            }
        } else if (!selectedIndustryName) {
            alert('Please select category first');

        } else if (!selectedSkillName) {
            alert('Please select subcategory ');

        }

        else {
            alert('Please select both a category and subcategory');
        }



    };
    const handleRecuiterSearch = () => {


        if (selectedIndustryName && selectedSkillName) {

            navigate(`/view-all-freelancer/${selectedIndustryName}/${selectedSkillName}`);



        } else if (!selectedIndustryName) {
            alert('Please select category first');

        } else if (!selectedSkillName) {
            alert('Please select subcategory  ');

        }
        else {
            alert('Please select both  category and subcategory');
        }




    }


    return (
        <>
            {videoLoading && <LoadingPannel />}
            {clientId ? (

                <div className="recuiter-home-page-container">
                    <div className="recuiter-home">
                        <img src="/image/freelancer-banner-home.webp" alt="Skilled Indian freelancers offering digital services" />
                        <div className="recuiter-home-content">
                            <h1>Land your dream job and project. </h1>
                            <h6>Connect businesses with local freelancers for efficient projects</h6>
                            <div className="recuiter-serach-filter-banner">
                                <select name=""
                                    value={selectedCategory}
                                    onChange={(e) => setSelectedCategory(e.target.value)}
                                    id="">
                                    <option value="">Select Items</option>
                                    {searchJobandProject.map((item) => (
                                        <option key={item.id} value={item.id} >{item.name}</option>
                                    ))}

                                </select>

                                <select class="recuiter-serach-filter-banner"
                                    name="Occupation_industry"
                                    onChange={handleIndustryChange}
                                    aria-label=".form-select-sm example">
                                    <option selected>Select Category</option>
                                    {industries.map((item) => (
                                        <option key={item.id} value={item?.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <select class="recuiter-serach-filter-banner"
                                    onChange={handleCategoryChange}
                                    value={formvalues?.Occupation_skills}
                                    aria-label=".form-select-sm example">
                                    <option selected>Select Subcategory</option>
                                    {subcategories.map((item) => (
                                        <option key={item} value={item?.name}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <button onClick={handleSearch}>Search</button>


                            </div>




                        </div>
                    </div>

                </div >
            ) : recuiterId ? (
                <div className="recuiter-home-page-container">
                    <div className="recuiter-home">
                        <img src="/image/recuiterhomebanner.webp" alt="Skilled Indian freelancers offering digital services" />
                        <div className="recuiter-home-content">
                            <h1>  Find Your Perfect talents </h1>
                            <h6>Connect businesses with local freelancers for efficient projects</h6>
                            <div className="recuiter-serach-filter-banner">
                                <h6>Find Talent</h6>
                                <select class="recuiter-serach-filter-banner"
                                    name="Occupation_industry"
                                    onChange={handleIndustryChange}
                                    aria-label=".form-select-sm example">
                                    <option selected>Select Category</option>
                                    {industries.map((item) => (
                                        <option key={item.id} value={item?.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <select class="recuiter-serach-filter-banner"
                                    onChange={handleCategoryChange}
                                    value={formvalues?.Occupation_skills}
                                    aria-label=".form-select-sm example">
                                    <option selected>Select Subcategory</option>
                                    {subcategories.map((item) => (
                                        <option key={item} value={item?.name}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <button onClick={handleRecuiterSearch}>Search</button>

                            </div>




                        </div>
                    </div>

                </div >
            ) : (
                <div className=" banner-container">
                    <video
                        autoPlay
                        playsInline
                        loop muted
                        ref={videoRef}
                        className='img-home-banner'
                        style={{
                            pointerEvents: 'none',
                            objectFit: 'cover'
                        }}
                        onCanPlay={handleVideoLoaded}
                    >
                        <source src=".\earth-moving.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <div className="banner-inner">
                        <div className="banner-flex1">
                            <h1 >Find Your Perfect Freelancers</h1>
                            <h2>OR Find Exciting Projects  All Nearby  !   </h2>
                            <h3>  Connect with skilled, local freelancers to get your projects done efficiently.</h3>
                            {/* <p><span style={{ color: "#FF3131" }}><b>Freelancers</b></span>: Find high-paying gigs and collaborate with businesses in your area.</p> */}

                            <div className="recuiter-serach-filter-banner">
                                <select name=""
                                    value={selectedFreelanceCategory}
                                    onChange={(e) => setSelectedFreelanceCategory(e.target.value)}
                                    id="">
                                    <option value="">Select Items</option>
                                    {searchFreelanceFilter.map((item) => (
                                        <option key={item.id} value={item.id} >{item.name}</option>
                                    ))}

                                </select>

                                <select class="form-select form-select-sm"
                                    name="Occupation_industry"
                                    onChange={handleIndustryChange}
                                    aria-label=".form-select-sm example">
                                    <option selected>Select Category</option>
                                    {industries.map((item) => (
                                        <option key={item.id} value={item?.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <select class="form-select form-select-sm"
                                    onChange={handleCategoryChange}
                                    value={formvalues?.Occupation_skills}
                                    aria-label=".form-select-sm example">
                                    <option selected>Select Subcategory</option>
                                    {subcategories.map((item) => (
                                        <option key={item} value={item?.name}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>


                                <button onClick={handleSearchNavigate}>Search</button>

                            </div>
                            <div className="trusted-container">
                                {trusted.map((item, index) => (
                                    <div key={index} className="trusted-item">
                                        <AvatarGroup max={5}>
                                            {['image1', 'image2', 'image3', 'image4', 'image5'].map((imageKey) => (
                                                item[imageKey] && (
                                                    <Avatar
                                                        key={`${index}-${imageKey}`}
                                                        alt={`Trusted User ${index + 1}`}
                                                        src={`${axiosApi.defaults.baseURL}${item[imageKey]}`}
                                                    />
                                                )
                                            ))}
                                        </AvatarGroup>
                                        <div className="raiting-trusted">
                                            <Rating
                                                value={item.rating}
                                                readOnly
                                                precision={0.5}
                                                style={{ marginTop: '10px' }}
                                            />
                                            <h6>Trusted by {item?.number}+ users</h6>
                                        </div>

                                    </div>
                                ))}
                            </div>

                            <div className='banner-inner-flex1-button'>
                                {clientId ? (
                                    null

                                ) : (

                                    <NavLink to='/register-as-freelancer'>
                                        <button  > Become Freelancer</button>
                                    </NavLink>
                                )}

                                {recuiterId ? (

                                    null
                                ) : (

                                    <NavLink to='/project-post'>
                                        <button  >Post Project</button>
                                    </NavLink>
                                )}
                            </div>
                        </div>
                        <div className="banner-flex2">
                            <div className="image-grid">
                                <img src="./image/menimg2.png" className="top-left" alt="Men Image 1" />
                                <img src="./image/menimg1.png" className="top-right" alt="Men Image 2" />
                                <img src="./image/menimg4.png" className="bottom-left" alt="Men Image 3" />
                                <img src="./image/menimg3.png" className="bottom-right" alt="Men Image 4" />
                            </div>
                        </div>
                    </div>
                </div>
            )}



        </>
    )
}

export default Banner